// Contract copy of the workstreams remote's ToastEvent (WorkstreamsUI/ActivityEditorDialog onToast).
export type ActivityEditorToastEvent = {
  type: 'success' | 'error';
  message: string;
  action?: { label: string; activityId: number };
  autoHideMs?: number;
};

// The workstreams dialog's modal root is z-index 1e6; the global #toast-container (999999) would sit under it.
const ABOVE_DIALOG_Z_INDEX = '1000001';

/**
 * Raises one toastr toast for a remote event that carries an action; events without one are dropped (the editor shows
 * errors inline). Content is built as DOM, so message and label render as text.
 */
export const showActivityEditorToast = ({
  type,
  message,
  action,
  autoHideMs,
}: ActivityEditorToastEvent) => {
  if (!action) return;

  const content = document.createElement('span');
  content.append(document.createTextNode(message));

  let $toast: unknown;
  if (Number.isFinite(action.activityId)) {
    const view = document.createElement('button');
    view.type = 'button';
    view.textContent = action.label;
    Object.assign(view.style, {
      marginLeft: '8px',
      padding: '0',
      border: '0',
      background: 'none',
      color: 'inherit',
      font: 'inherit',
      fontWeight: 'bold',
      textDecoration: 'underline',
      cursor: 'pointer',
    });
    view.addEventListener('click', (e) => {
      // Only this element navigates; toastr's own tap-to-dismiss would also fire on the toast.
      e.stopPropagation();
      toastr.clear($toast, { force: true });
      window.openFullPopupV1(String(action.activityId));
    });
    content.append(view);
  }

  // One toast on screen: remove the previous one at once (clear() fades it out for 1 s, overlapping the next).
  toastr.remove();
  const container: HTMLElement = toastr.getContainer(undefined, true)[0];
  $toast = (type === 'error' ? toastr.error : toastr.success)(content, '', {
    ...(Number.isFinite(autoHideMs) && { timeOut: autoHideMs }),
    // Restore on hide; the container is also discarded with its last toast.
    onHidden: () => {
      container.style.zIndex = '';
    },
  });
  container.style.zIndex = ABOVE_DIALOG_Z_INDEX;
};
